import { immutableRecords } from "../../../types";
import definitionActionTypes from "../actions";
import { calendarActionTypes } from "../calendar";
import { isCalendarTypeRelative } from "../calendar/selectors";
import { typeActionTypes } from "../types";
import { toggleViewSettingsShowRelationshipTypes } from "../utils";
import { actionTypes } from "./actions";

const getRangeLimits = (limit1, limit2) => {
  const from = Math.min(limit1, limit2);
  const to = Math.max(limit1, limit2);
  return { from, to };
};

const changeZoomLimits = (state, limit1, limit2) => {
  const { from, to } = getRangeLimits(limit1, limit2);
  return state.merge({
    zoomFrom: from,
    zoomTo: to
  });
};

const reducer = (state = immutableRecords.TimelineViewSettingsRecord({}), action, _prevGlobalState) => {
  switch (action.type) {
    case actionTypes.CHANGE_SHOW_IDENTIFIER:
      return state.set("showIdentifier", action.show);
    case actionTypes.CHANGE_SHOW_DATES:
      return state.set("showDates", action.show);
    case actionTypes.CHANGE_SHOW_DURATION:
      return state.set("showDuration", action.show);
    case actionTypes.CHANGE_SHOW_NARRATIVE:
      return state.set("showNarrative", action.show);
    case actionTypes.TOGGLE_SHOW_RELATIONSHIP_TYPES:
      return toggleViewSettingsShowRelationshipTypes(state, action.typeIds);
    case actionTypes.CHANGE_SHOW_BLOCKS:
      return state.set("showBlocks", action.show);
    case actionTypes.CHANGE_SHOW_BLOCKED_BY:
      return state.set("showBlockedBy", action.show);
    case actionTypes.CHANGE_SHOW_IMAGE:
      return state.set("showImage", action.show);
    case actionTypes.CHANGE_SHOW_SUMMARY:
      return state.set("showSummary", action.show);
    case actionTypes.CHANGE_SHOW_INFO_ICONS:
      return state.set("showInfoIcons", action.show);
    case actionTypes.CHANGE_SHOW_DEPENDENCIES:
      return state.set("showDependencies", action.show);
    case actionTypes.CHANGE_SHOW_TODAY_LINE:
      return state.set("showTodayLine", action.show);
    case actionTypes.CHANGE_SHOW_ITEM_CARD:
      return state.set("showItemCard", action.show);
    case actionTypes.CHANGE_SHOW_TYPE:
      return action.show
        ? state.update("showTypes", l => l.push(action.typeId))
        : state.update("showTypes", l => l.filterNot(t => t === action.typeId));
    case actionTypes.CHANGE_ZOOM_FROM:
      return changeZoomLimits(state, action.zoomFrom, state.zoomTo);
    case actionTypes.CHANGE_ZOOM_TO:
      return changeZoomLimits(state, state.zoomFrom, action.zoomTo);
    case actionTypes.CHANGE_LAYOUT:
      return state.set("eventLayout", action.layout);
    case calendarActionTypes.CHANGE_CALENDAR_TYPE:
      return isCalendarTypeRelative(action.calendarType) ? state.set("showTodayLine", false) : state;
    case definitionActionTypes.APPLY_VIEW_SETTINGS_TO_ALL_VIEWS:
      return state.merge(action.viewSettings);
    //#!if readonly !== true
// case typeActionTypes.CHANGE_CAN_HAVE_DATE:
// return action.canHaveDate ? state : state.update("showTypes", l => l.filterNot(t => t === action.id));
    //#!endif
    default:
      return state;
  }
};

export default reducer;
